import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { getHandleAddress } from 'bento-ordering/utils/openAddress';
import SecondaryCta from 'bento-ordering/base/components/SecondaryCta';
import usePlainSecondaryCtaStyles from 'bento-ordering/base/style_hooks/usePlainSecondaryCtaStyles';

const AddressLink = ({
  street,
  city,
  state,
  postalCode,
  googlePlaceId,
  handleClick,
  dataTestId
}) => {
  const styles = usePlainSecondaryCtaStyles();
  const processedHandleClick =
    getHandleAddress({
      street,
      city,
      state,
      postalCode,
      googlePlaceId
    }) || handleClick;

  return (
    <SecondaryCta
      label={
        <Typography>
          {street}, {city}, {state} {postalCode}
        </Typography>
      }
      classes={styles}
      handleClick={processedHandleClick}
      dataTestId={dataTestId}
    />
  );
};

AddressLink.propTypes = {
  street: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  postalCode: PropTypes.string,
  googlePlaceId: PropTypes.string,
  handleClick: PropTypes.func,
  dataTestId: PropTypes.string
};

AddressLink.defaultProps = {
  handleClick: () => {}
};

export default AddressLink;
